import { render, staticRenderFns } from "./bigAreaReport.vue?vue&type=template&id=2f6286d0"
import script from "./bigAreaReport.vue?vue&type=script&lang=ts"
export * from "./bigAreaReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports